import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-all",
  "use": "icon-all-usage",
  "viewBox": "0 0 1046 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1046 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-all\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 2.709h448.101V450.81H0z\" p-id=\"4695\" /><path d=\"M605.86 0h439.659v439.658H605.86z\" p-id=\"4696\" /><path d=\"M1.442 575.887h448.102v448.101H1.442z m605.85-2.709h439.657v439.658H607.291z\" p-id=\"4697\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/all.svg
// module id = QcK0
// module chunks = 77